import React from "react";

function FlexGrowSpace() {
  return <div style={{ flexGrow: 1 }}></div>;
}

export default FlexGrowSpace;
